import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import parse from 'html-react-parser';
import { useEffect, useRef, useState } from 'react';
import { TermsProps } from '../../interfaces/props/TermsProps';
import './styles.css';
import { sxCheckbox, sxCheckboxContrast } from '../../assets/styles/CommonSxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

const Terms: React.FC<TermsProps> = ({ toggleCheck, terms, acceptText, justView }) => {

  const [readed, setReaded] = useState<boolean>(false);

  const termosRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    termosRef?.current?.focus();
  }, []);

  const { contrastMode, contrastColorAccessibility } = useAccessibility();

  const handleScroll = (event: React.UIEvent<HTMLElement>) => {
    if (!readed) {
      const target = event.target as HTMLElement;
      const pixelsTolerance = 200;
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + pixelsTolerance) {
        setReaded(true);
      } else {
        setReaded(false);
      }
    }
  }

  return (
    <div className="terms-of-use-holder">
      <div className="terms-holder">
        <div className="terms" onScroll={handleScroll} tabIndex={0} ref={termosRef}>
          {parse(terms.descricao)}
        </div>
      </div>
      {!justView && 
      <div>
        <FormControlLabel 
          disabled={!readed} 
          control={<Checkbox 
                      style={contrastColorAccessibility} 
                      onChange={toggleCheck} 
                  />} 
        label={parse(acceptText)} 
        sx={contrastMode ? sxCheckboxContrast : sxCheckbox} />
      </div>
      }
    </div>
  )
}

export default Terms;